/**
 * custom-stock-limit.js
 *
 * Limita la cantidad que el cliente puede comprar al stock real disponible y
 * muestra un mensaje claro cuando intenta superarlo.
 *
 * Se apoya en el atributo "max" que calcula el snippet
 * snippets/quantity-selector.liquid, por lo que funciona igual en la pagina de
 * producto, en el carrito (pagina y drawer) y en el quick order list.
 */
(function () {
  'use strict';

  var MESSAGE_CLASS = 'stock-limit-message';
  var HIDE_DELAY = 6000;
  var COMPONENTS = 'quantity-selector-component, cart-quantity-selector-component';
  var INPUT_SELECTOR = 'input[ref="quantityInput"]';

  var defaults = {
    one: 'Solo queda 1 unidad disponible.',
    other: 'Solo quedan %count% unidades disponibles.',
    none: 'No quedan mas unidades disponibles.'
  };

  var overrides = window.stockLimitStrings || {};
  var texts = {
    one: overrides.one || defaults.one,
    other: overrides.other || defaults.other,
    none: overrides.none || defaults.none
  };

  var timers = new WeakMap();

  function toInt(value) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? null : parsed;
  }

  function getComponent(element) {
    return element && element.closest ? element.closest(COMPONENTS) : null;
  }

  // Unidades que todavia se pueden comprar, descontando lo que ya hay en el carrito.
  function getRemaining(input) {
    var max = toInt(input.getAttribute('max'));

    if (max === null) {
      return null;
    }

    if (input.hasAttribute('data-cart-line')) {
      return max;
    }

    var inCart = toInt(input.getAttribute('data-cart-quantity')) || 0;

    return max - inCart;
  }

  // Maximo que aceptara el propio componente del tema.
  function getEffectiveMax(input) {
    var component = getComponent(input);

    if (component && typeof component.getEffectiveMax === 'function') {
      try {
        return component.getEffectiveMax();
      } catch (error) {
        // Si el componente del tema falla, usamos el calculo manual.
      }
    }

    var remaining = getRemaining(input);

    if (remaining === null) {
      return null;
    }

    if (input.hasAttribute('data-cart-line')) {
      return remaining;
    }

    return Math.max(remaining, toInt(input.getAttribute('min')) || 1);
  }

  function buildText(input) {
    var remaining = getRemaining(input);

    if (remaining === null) {
      return '';
    }

    if (remaining <= 0) {
      return texts.none;
    }

    if (remaining === 1) {
      return texts.one;
    }

    return texts.other.replace('%count%', String(remaining));
  }

  function getMessageElement(input) {
    var anchor =
      input.closest('.cart-items__quantity-controls') ||
      input.closest('.quantity-selector-wrapper') ||
      getComponent(input);

    if (!anchor || !anchor.parentNode) {
      return null;
    }

    var existing = anchor.parentNode.querySelector('.' + MESSAGE_CLASS);

    if (existing) {
      return existing;
    }

    var element = document.createElement('div');

    element.className = MESSAGE_CLASS;
    element.setAttribute('role', 'status');
    element.setAttribute('aria-live', 'polite');
    element.hidden = true;
    anchor.parentNode.insertBefore(element, anchor.nextSibling);

    return element;
  }

  function showMessage(input) {
    var text = buildText(input);

    if (!text) {
      return;
    }

    var element = getMessageElement(input);

    if (!element) {
      return;
    }

    element.textContent = text;
    element.hidden = false;

    if (timers.has(element)) {
      clearTimeout(timers.get(element));
    }

    timers.set(element, setTimeout(function () {
      element.hidden = true;
    }, HIDE_DELAY));
  }

  function isQuantityInput(node) {
    return !!node && node.tagName === 'INPUT' && node.getAttribute('ref') === 'quantityInput';
  }

  // El cliente escribe una cantidad mayor que el stock disponible.
  document.addEventListener('input', function (event) {
    var input = event.target;

    if (!isQuantityInput(input) || !input.hasAttribute('max')) {
      return;
    }

    var effectiveMax = getEffectiveMax(input);
    var typed = toInt(input.value);

    if (effectiveMax !== null && typed !== null && typed > effectiveMax) {
      showMessage(input);
    }
  }, true);

  // El cliente alcanza el maximo con el boton de sumar.
  document.addEventListener('click', function (event) {
    var target = event.target;
    var trigger = target && target.closest ? target.closest('.quantity-plus') : null;

    if (!trigger) {
      return;
    }

    var component = getComponent(trigger);
    var input = component ? component.querySelector(INPUT_SELECTOR) : null;

    if (!input || !input.hasAttribute('max')) {
      return;
    }

    setTimeout(function () {
      var effectiveMax = getEffectiveMax(input);
      var value = toInt(input.value);

      if (effectiveMax !== null && value !== null && value >= effectiveMax) {
        showMessage(input);
      }
    }, 0);
  }, true);
})();
